import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IRemoteTilesetFieldsFragment = {
  id?: any | null
  source: string
  name: string
  projectId: any
}

export type IGetRemoteTilesetsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetRemoteTilesetsQuery = {
  remoteTilesets?: {
    data: Array<{
      id?: any | null
      source: string
      name: string
      projectId: any
    }>
  } | null
}

export type IListenRemoteTilesetsByProjectIdSubscriptionVariables =
  Types.Exact<{
    projectId: Types.Scalars['ObjectId']['input']
  }>

export type IListenRemoteTilesetsByProjectIdSubscription = {
  remoteTileset?: {
    id?: any | null
    item?: {
      id?: any | null
      source: string
      name: string
      projectId: any
    } | null
  } | null
}

export type ISaveRemoteTilesetMutationVariables = Types.Exact<{
  remoteTileset: Types.IRemoteTilesetInput
}>

export type ISaveRemoteTilesetMutation = {
  saveRemoteTileset?: {
    id?: any | null
    source: string
    name: string
    projectId: any
  } | null
}

export type IDeleteRemoteTilesetsMutationVariables = Types.Exact<{
  ids:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
}>

export type IDeleteRemoteTilesetsMutation = {
  deleteManyRemoteTilesets?: boolean | null
}

export const RemoteTilesetFieldsFragmentDoc = gql`
  fragment RemoteTilesetFields on RemoteTileset {
    id
    source
    name
    projectId
  }
`
export const GetRemoteTilesetsDocument = gql`
  query GetRemoteTilesets($projectId: ObjectId!) {
    remoteTilesets(projectId: $projectId) {
      data {
        ...RemoteTilesetFields
      }
    }
  }
  ${RemoteTilesetFieldsFragmentDoc}
`

/**
 * __useGetRemoteTilesetsQuery__
 *
 * To run a query within a React component, call `useGetRemoteTilesetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteTilesetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteTilesetsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRemoteTilesetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetRemoteTilesetsQuery,
    IGetRemoteTilesetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetRemoteTilesetsQuery,
    IGetRemoteTilesetsQueryVariables
  >(GetRemoteTilesetsDocument, options)
}
export function useGetRemoteTilesetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetRemoteTilesetsQuery,
    IGetRemoteTilesetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetRemoteTilesetsQuery,
    IGetRemoteTilesetsQueryVariables
  >(GetRemoteTilesetsDocument, options)
}
export type GetRemoteTilesetsQueryHookResult = ReturnType<
  typeof useGetRemoteTilesetsQuery
>
export type GetRemoteTilesetsLazyQueryHookResult = ReturnType<
  typeof useGetRemoteTilesetsLazyQuery
>
export type GetRemoteTilesetsQueryResult = Apollo.QueryResult<
  IGetRemoteTilesetsQuery,
  IGetRemoteTilesetsQueryVariables
>
export const ListenRemoteTilesetsByProjectIdDocument = gql`
  subscription ListenRemoteTilesetsByProjectId($projectId: ObjectId!) {
    remoteTileset(projectId: $projectId) {
      id
      item {
        ...RemoteTilesetFields
      }
    }
  }
  ${RemoteTilesetFieldsFragmentDoc}
`

/**
 * __useListenRemoteTilesetsByProjectIdSubscription__
 *
 * To run a query within a React component, call `useListenRemoteTilesetsByProjectIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenRemoteTilesetsByProjectIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenRemoteTilesetsByProjectIdSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenRemoteTilesetsByProjectIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenRemoteTilesetsByProjectIdSubscription,
    IListenRemoteTilesetsByProjectIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenRemoteTilesetsByProjectIdSubscription,
    IListenRemoteTilesetsByProjectIdSubscriptionVariables
  >(ListenRemoteTilesetsByProjectIdDocument, options)
}
export type ListenRemoteTilesetsByProjectIdSubscriptionHookResult = ReturnType<
  typeof useListenRemoteTilesetsByProjectIdSubscription
>
export type ListenRemoteTilesetsByProjectIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenRemoteTilesetsByProjectIdSubscription>
export const SaveRemoteTilesetDocument = gql`
  mutation SaveRemoteTileset($remoteTileset: RemoteTilesetInput!) {
    saveRemoteTileset(remoteTileset: $remoteTileset) {
      ...RemoteTilesetFields
    }
  }
  ${RemoteTilesetFieldsFragmentDoc}
`
export type ISaveRemoteTilesetMutationFn = Apollo.MutationFunction<
  ISaveRemoteTilesetMutation,
  ISaveRemoteTilesetMutationVariables
>

/**
 * __useSaveRemoteTilesetMutation__
 *
 * To run a mutation, you first call `useSaveRemoteTilesetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRemoteTilesetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRemoteTilesetMutation, { data, loading, error }] = useSaveRemoteTilesetMutation({
 *   variables: {
 *      remoteTileset: // value for 'remoteTileset'
 *   },
 * });
 */
export function useSaveRemoteTilesetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveRemoteTilesetMutation,
    ISaveRemoteTilesetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveRemoteTilesetMutation,
    ISaveRemoteTilesetMutationVariables
  >(SaveRemoteTilesetDocument, options)
}
export type SaveRemoteTilesetMutationHookResult = ReturnType<
  typeof useSaveRemoteTilesetMutation
>
export type SaveRemoteTilesetMutationResult =
  Apollo.MutationResult<ISaveRemoteTilesetMutation>
export type SaveRemoteTilesetMutationOptions = Apollo.BaseMutationOptions<
  ISaveRemoteTilesetMutation,
  ISaveRemoteTilesetMutationVariables
>
export const DeleteRemoteTilesetsDocument = gql`
  mutation DeleteRemoteTilesets($ids: [ObjectId!]!) {
    deleteManyRemoteTilesets(ids: $ids)
  }
`
export type IDeleteRemoteTilesetsMutationFn = Apollo.MutationFunction<
  IDeleteRemoteTilesetsMutation,
  IDeleteRemoteTilesetsMutationVariables
>

/**
 * __useDeleteRemoteTilesetsMutation__
 *
 * To run a mutation, you first call `useDeleteRemoteTilesetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRemoteTilesetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRemoteTilesetsMutation, { data, loading, error }] = useDeleteRemoteTilesetsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteRemoteTilesetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteRemoteTilesetsMutation,
    IDeleteRemoteTilesetsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteRemoteTilesetsMutation,
    IDeleteRemoteTilesetsMutationVariables
  >(DeleteRemoteTilesetsDocument, options)
}
export type DeleteRemoteTilesetsMutationHookResult = ReturnType<
  typeof useDeleteRemoteTilesetsMutation
>
export type DeleteRemoteTilesetsMutationResult =
  Apollo.MutationResult<IDeleteRemoteTilesetsMutation>
export type DeleteRemoteTilesetsMutationOptions = Apollo.BaseMutationOptions<
  IDeleteRemoteTilesetsMutation,
  IDeleteRemoteTilesetsMutationVariables
>
